<template>
  <main class="page">
    <section class="page__intro page__intro--left">
      <h1 class="page__title page__title--green">Min profil</h1>
      <h2>Möjlighet att justera dina profiluppgifter.</h2>
      <p>Vi hämtar kontinuerligt in uppgifter från aktörer men vi behöver även verifiera att de är rätt angivna. Därför behöver vi att även du fyller på med uppdaterad information.</p>
    </section>
    <div class="page__main">
      <section class="settings__message">
        <transition name="fade">
          <p :key="message" v-show="message !== ''">
            {{ message }}
          </p>
        </transition>
      </section>
      <section class="item">
        <SettingsItem v-for="(data,index) in settingsItemData" :key="'i' + index" :setting="data"/>
        <SettingsDropdown v-for="(data,index) in settingsData" :key="index" :setting="data"/>
      </section>
    </div>
  </main>
</template>

<script>
import {LoadingSpinner, SettingsItem } from '../components/';
import SettingsDropdown from '../components/settings/SettingsDropdown.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Settings',
  data() {
    return {
      message: ''
    }
  },
  created () {
    if(!this.collectiveAgreements.status) {
      this.getCollectiveAgreements()
    }
  },
  components: {
    SettingsDropdown, LoadingSpinner, SettingsItem
  },
  methods: {
    ...mapActions(['getCollectiveAgreements']),
  },
  computed: {
    ...mapGetters([ 'user', 'collectiveAgreements' ]),
    settingsItemData() {
      let access = this.user.access;

      return ([
        {
          "title": "Inkomster",
          "field": "income",
          "firstValue": access.income.monthlySalary,
          "secondValue": access.income.averagePayIncreases,
          "labelOne": "Månadslön",
          "labelTwo": "Beräknad årlig löneökning"
        }
      ])
    },
    settingsData () {
      let access = this.user.access;

      let data = {
        'name': 'Jag har inget kollektivavtal',
        'id': 100
      }

      return ([
        {
          title: "Kollektivavtal",
          options: {
            ...this.collectiveAgreements.agreements,
            data
          },
          choosen: access.collectiveAgreement
        }
      ])
    }
  },
}
</script>

<style lang="scss" scoped>
.item {
  > div:last-of-type {
    margin-bottom: 0;
  }
}
</style>